import axios from 'axios'
import qs from 'qs'

// const host = process.env.NODE_ENV === 'production' ? 'http://192.168.3.100:8081' : 'http://192.168.3.100:8081'

var service = axios.create({
  // baseURL: 'https://xiaoyu.jsh178.com'
  // baseURL: 'http://192.168.3.40:8081' // 商海鹏
})
// 请求拦截
service.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    // console.log('1111', config)
    config.data = qs.stringify(config.data)

    return config
  },
  function (error) {
    // Do something with request error
    // console.log(error)
    return Promise.reject(error)
  }
)

// Add a response interceptor
// 响应拦截
service.interceptors.response.use(
  function (response) {
    // Do something with response data
    // console.log('wahaha', response)
    // if (response.status === 300) {
    //   window.localStorage.removeItem('token')
    //   // this.$router.push('/login')
    //   window.location.reload()
    // }
    return response
  },
  function (error) {
    // console.log('sssssssssss', error)
    if (error && error.response) {
      switch (error.response.status) {
        case 404:
          // router.push({name: 'error-404'})
          // // error.message = '请求出错(404)'
          break
        case 500:
          // router.push({ name: 'error-500'})
          // //  error.message = '服务器错误(500)';
          break
        case 300:
          window.localStorage.removeItem('token')
          // window.$router.push('/login')
          window.location.reload()
          break
        default:
          error.message = `连接出错(${error.response.status})!`
      }
    }

    // Do something with response error
    // window.localStorage.removeItem('token')
    // window.$router.push('/login')
    return Promise.reject(error)
  }
)

export default service
